<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
  >
    <v-card class="pa-5">
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        {{ cdText }}
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn()"
          @submit.prevent
        >
          <v-radio-group
            v-model="invoiceOption"
            class="colored-options"
            data-testid="invoice-options"
          >
            <v-radio
              key="sendInvoice"
              value="sendInvoice"
              color="accent"
              class="black--text pa-5 option rounded-xxl"
              data-testid="invoice-option-2"
              active-class="selected"
            >
              <template v-slot:label>
                <div>
                  <span class="text-subtitle-1 font-weight-bold">{{
                    $t("sendThroughSkillboost")
                  }}</span
                  ><br />
                  <span
                    class="text-subtitle-2 grey--text font-weight-regular"
                    >{{ $t("approveAndSend") }}</span
                  >
                </div>
              </template>
            </v-radio>
            <v-radio
              v-if="integrationIds.fortnox"
              key="sendViaFortnox"
              value="sendViaFortnox"
              color="accent"
              class="black--text pa-5 option rounded-xxl"
              data-testid="invoice-option-1"
              active-class="selected"
              @click="selectedintegrationId = integrationIds.fortnox"
            >
              <template v-slot:label>
                <div>
                  <span class="text-subtitle-1 font-weight-bold">{{
                    $t("sendThroughFortnox")
                  }}</span
                  ><br />
                  <span
                    class="text-subtitle-2 grey--text font-weight-regular"
                    >{{ $t("sendThroughFortnoxText") }}</span
                  >
                </div>
              </template>
            </v-radio>
            <v-radio
              v-if="integrationIds.visma"
              key="sendViaVisma"
              value="sendViaVisma"
              color="accent"
              class="black--text pa-5 option rounded-xxl"
              data-testid="invoice-option-1"
              active-class="selected"
              @click="selectedintegrationId = integrationIds.visma"
            >
              <template v-slot:label>
                <div>
                  <span class="text-subtitle-1 font-weight-bold">{{
                    $t("sendThroughVisma")
                  }}</span
                  ><br />
                  <span
                    class="text-subtitle-2 grey--text font-weight-regular"
                    >{{ $t("sendThroughVismaText") }}</span
                  >
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 cancel"
          :disabled="loading"
          @click="show = false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          v-if="
            invoiceOption !== 'sendViaFortnox' &&
            invoiceOption !== 'sendViaVisma'
          "
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 submit"
          :loading="loading"
          @click="submitDialogBtn()"
        >
          {{ cdSubmitBtn }}
        </v-btn>
        <v-btn
          v-if="
            invoiceOption == 'sendViaFortnox' || invoiceOption == 'sendViaVisma'
          "
          ref="select-customer"
          data-testid="select-customer-button"
          type="button"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 submit"
          @click.stop="dialogVisibleFetchCustomers = true"
          >{{ $t("next") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmationDialogFortnoxCustomer
      v-if="dialogVisibleFetchCustomers"
      :visible="dialogVisibleFetchCustomers"
      :integrationId="this.selectedintegrationId"
      :integrationType="this.invoiceOption"
      :orderId="this.orderId"
      data-testid="confirmation-dialog-fetch-customer"
      @close="dialogVisibleFetchCustomers = false"
      @proceedSubmit="submitDialogBtn($event)"
    />
  </v-dialog>
</template>
<script>
import i18n from "../plugins/i18n";
import ConfirmationDialogFortnoxCustomer from "./ConfirmationDialogFortnoxCustomer";

export default {
  components: {
    ConfirmationDialogFortnoxCustomer,
  },
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: "",
    },
    integrationIds: {
      type: Object,
      default: () => {},
    },
    orderId: {
      type: String,
      default: "",
    },
    cdText: {
      type: String,
      default: "",
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t("submit"),
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t("cancel"),
    },
    title: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: true,
      alertMsg: "",
      check: false,
      dialogVisibleFetchCustomers: false,
      invoiceOption: "sendInvoice",
      customer: "",
      selectedintegrationId:
        this.integrationIds.fortnox ?? this.integrationIds.visma ?? null,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
          this.$refs.form.reset();
        }
      },
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.form.validate();
    });
  },
  methods: {
    submitDialogBtn(data) {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        if (data) {
          this.$emit("proceedSubmit", {
            customerNumber: data.customerNumber,
            method: this.invoiceOption,
            articleId: data.articleId,
          });
        } else {
          this.$emit("proceedSubmit", {});
        }
      }
    },
  },
};
</script>
